/**
 * 需要想定サブステップ (linked_page_kind = DEMAND_FORECAST_DAILY) の到達判定
 * (AC-DFC-004b、demand-confirm-step-guard-error-messages design Decision #1)。
 *
 * `wfCase.bigSteps[].subSteps[]` から需要想定サブステップを引き、backend
 * 算出済みの derived `status` (`GetWorkflowCase` レスポンスに既に入っている)
 * を読むだけの thin read (既存 `demand_step_confirmed` 読み
 * `~/models/workflowCaseReadonly.ts` と同型 — proto 変更不要)。
 *
 * 需要想定サブステップの識別は `linkedPageKind ===
 * LinkedPageKind.DEMAND_FORECAST_DAILY`（sub_step にドメイン種別 enum は無く
 * この field が唯一の識別子。既存 map `~/models/linkedPage.ts`）。
 */
import type { WorkflowCase } from '@ebalance/proto/bffuser/v1/workflow_case_model_pb'
import { SubStepStatus } from '@ebalance/proto/bffuser/v1/workflow_case_model_pb'
import { LinkedPageKind } from '@ebalance/proto/bffuser/v1/workflow_template_model_pb'

/**
 * wfCase の需要想定サブステップ (linked_page_kind = DEMAND_FORECAST_DAILY)
 * の derived status を返す。 該当サブステップが存在しない (雛形に含まれない)
 * 場合は undefined。
 */
export function demandForecastSubStepStatus(
  wfCase: WorkflowCase,
): SubStepStatus | undefined {
  for (const bigStep of wfCase.bigSteps) {
    for (const subStep of bigStep.subSteps) {
      if (subStep.linkedPageKind === LinkedPageKind.DEMAND_FORECAST_DAILY) {
        return subStep.status
      }
    }
  }
  return undefined
}

/**
 * 需要想定サブステップが未到達 (= ワークフローの前のステップが完了して
 * おらず NOT_STARTED) か判定する (AC-DFC-004b)。サブステップ不在
 * (undefined、= 判定不能) は false (= 到達扱い、既存 disabled 条件に影響
 * しない fail-open) とする — `~/models/workflowCaseReadonly.ts` の
 * `demand_step_confirmed` 未 set 時の fallback 方針と同型。
 */
export function isDemandForecastSubStepNotReached(
  wfCase: WorkflowCase,
): boolean {
  return demandForecastSubStepStatus(wfCase) === SubStepStatus.NOT_STARTED
}
